<template>
    <div>
        <div class="table-area">
            <div class="table-b" style="margin-bottom: 10px">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">방문객 정보<span style="color: #FF7F50; font-size: 16px" v-if="this.blackInfoYn">&nbsp ■ 블랙리스트 대상자</span></h3>
                    </div>
                </div>
                <div class="grid-wrap">
                    <dhx-grid ref="grid" v-model="visitorList" :config="config" @constructGridSuccessful="constructGridSuccessful"/>
                </div>
            </div>
            <visitor-history v-model="value" :visitorSeq="visitorSeq" :visitorNm="visitorNm" v-if="visitStat=='50' || visitStat=='60'"  @input="$forceUpdate()"/>
        </div>
        <!-- //테이블 -->
    </div>
</template>

<script>
    import mixin from '@/mixin';
    import mixinSlip from '@/mixin/slip';
    import _ from 'lodash'
    import DhxGrid from '@/components/DhxGrid.vue'
    import VisitorHistory from '@/components/visit/VisitorHistory.vue'
    import SecuDetail from '@/components/SecuDetail.vue'
    import CarDetail from '@/components/CarDetail.vue'

    export default {
        name: 'VisitorControl',
        props: {
            'value': {
                type: Object,
                required: true
            }
        },
        mixins: [mixin, mixinSlip],
        components: {DhxGrid, VisitorHistory, SecuDetail, CarDetail},
        data() {
            return {
                config : {
                    columns: [
                        {id: 'visitorSeq', type: 'ro', align: 'center',value: 'No.',width: 35},
                        {id: 'visitorNm',align: 'center',value: '방문자명',width: 50},
                        {id: 'visitorBirth',align: 'center',value: '생년월일',width: 80},
                        {id: 'visitorMobile',align: 'center',value: '연락처',width: 100},
                        {
                            value: '보안물품',
                            component: {
                                template: `<div class="btn-wrapper" v-if="this.value.secuYn ==='Y'"><button type="button" class="btn btn-primary btn-block" @click="showSecuDetail()">내역</button></div>`,
                                methods: {
                                    showSecuDetail() {
                                        this.$modal.open({
                                            component: SecuDetail,
                                            props: {
                                                visitNo: this.$parent.$parent.value.visitNo,
                                                visitorSeq: this.value.visitorSeq,
                                                visitorNm: this.value.visitorNm
                                            },
                                            parent: this,
                                            width: 1000
                                        })
                                    },
                                }
                            },
                            width: 50
                        },
                        {
                            value: '차량정보',
                            component: {
                                template: `<div class="btn-wrapper" v-if="this.value.carYn ==='Y'"><button type="button" class="btn btn-primary btn-block" @click="showCarDetail()">내역</button></div>`,
                                methods: {
                                    showCarDetail() {
                                        this.$modal.open({
                                            component: CarDetail,
                                            props: {
                                                visitNo: this.$parent.$parent.value.visitNo,
                                                visitorSeq: this.value.visitorSeq,
                                                visitorNm: this.value.visitorNm
                                            },
                                            parent: this,
                                            width: 800
                                        })
                                    },
                                }
                            },
                            width: 50
                        },
                        {
                            value: '입퇴실처리',
                            component: {
                                template: `<div class="btn-wrapper" v-if="this.show ==='Y'"><button type="button" class="btn btn-primary btn-block" @click="doInProcess()">입실</button></div>
                                           <div class="btn-wrapper" v-else-if="this.show ==='N'"><button type="button" class="btn btn-orange btn-block" @click="doOutProcess()">퇴실</button></div>
                                           <div class="btn-wrapper" v-else-if="this.show ==='R'"><button type="button" class="btn btn-default btn-block" @click="showRefuse()">거부된 인원</button></div>
                                           <div class="btn-wrapper" v-else-if="this.show ==='F'"><button type="button" class="btn btn-default btn-block" @click="showAlert()">미해당</button></div>`,
                                data() {
                                    return {show: ''}
                                },
                                mounted() {
                                    this.checkTime()
                                },
                                methods: {
                                    doInProcess() {
                                        this.$http.post(`/api/visit/checkVisitorTime`, this.value
                                        ).then((response) => {
                                                this.show = response.data === 0 ? 'Y' : 'N';
                                            if( this.show === 'Y') {
                                                this.$swal({
                                                    type: 'info',
                                                    text: `입실처리를 진행합니다. 계속 하시겠습니까?`,
                                                    showCancelButton: true,
                                                    confirmButtonText: '예',
                                                    cancelButtonText: '아니오',
                                                }).then((result) => {
                                                    if (result.value) {
                                                        this.$http.post(`/api/visit/save/visitor/inTime`, this.value
                                                        ).then((response) => {
                                                            this.$swal({
                                                                type: 'success', text: '완료되었습니다.'
                                                            }).then((result) => {
                                                                this.$parent.$parent.visitorSeq = this.value.visitorSeq
                                                                this.checkTime()
                                                            });
                                                        }).catch((e) => {
                                                            console.error(e);
                                                        });
                                                    }
                                                });
                                            } else {
                                                this.$swal({
                                                    type: 'error', text: '입실 내역이 있습니다. 확인 후 작업해주세요.'
                                                }).then((result) => {
                                                    this.$parent.$parent.visitorSeq = this.value.visitorSeq
                                                })
                                            }
                                        }).catch((e) => {
                                            console.error(e);
                                        })
                                    },
                                    doOutProcess() {
                                        this.$http.post(`/api/visit/checkVisitorTime`, this.value
                                        ).then((response) => {
                                            this.show = response.data === 0 ? 'Y' : 'N';
                                            if( this.show === 'N') {
                                                this.$swal({
                                                    type: 'info',
                                                    text: `퇴실처리를 진행합니다. 계속 하시겠습니까?`,
                                                    showCancelButton: true,
                                                    confirmButtonText: '예',
                                                    cancelButtonText: '아니오',
                                                }).then((result) => {
                                                    if (result.value) {
                                                        this.$http.post(`/api/visit/save/visitor/outTime`, this.value
                                                        ).then((response) => {
                                                            this.$swal({
                                                                type: 'success', text: '완료되었습니다.'
                                                            }).then((result) => {
                                                                this.$parent.$parent.visitorSeq = this.value.visitorSeq
                                                                this.checkTime()
                                                            });
                                                        }).catch((e) => {
                                                            console.error(e);
                                                        });
                                                    }
                                                });
                                            } else {
                                                this.$swal({
                                                    type: 'error', text: '퇴실할 내역이 없습니다. 확인 후 작업해주세요.'
                                                }).then((result) => {
                                                    this.$parent.$parent.visitorSeq = this.value.visitorSeq
                                                })
                                            }
                                        }).catch((e) => {
                                            console.error(e);
                                        })
                                    },
                                    showRefuse() {
                                        this.$swal({
                                            type: 'error', text: '결재과정에서 거부처리된 인원입니다.'
                                        })
                                    },
                                    showAlert() {
                                        this.$swal({
                                            type: 'error', text: '입퇴실 조건에 해당되지 않습니다.'
                                        })
                                    },
                                    checkTime() {
                                        let staDt = this.$parent.$parent.toPure(this.$parent.$parent.value.staYmd)
                                        let endDt = this.$parent.$parent.toPure(this.$parent.$parent.value.endYmd)

                                        this.$http.post(`/api/visit/checkVisitorTime`, this.value
                                        ).then((response) => {
                                            if(response.data !== 0){
                                                this.show = 'N'
                                            } else {
                                                if (this.$parent.$parent.value.visitStatCd !== '50') {
                                                    this.show = 'F'
                                                    return
                                                }

                                                if(this.$parent.$parent.today >= staDt && this.$parent.$parent.today <= endDt) {
                                                    if(this.value.allowYn === 'Y')
                                                        this.show = 'Y'
                                                    else
                                                        this.show = 'R'
                                                } else {
                                                    this.show = 'F'
                                                }
                                            }
                                        }).catch((e) => {
                                            console.error(e);
                                        })
                                    }
                                }
                            },
                            width: 50
                        },
                        {id: 'blackYn',align: 'center',value: '블랙여부',width: 100, hide:true},
                    ],
                    height: 240,
                    enablePaging: false,
                    afterRefreshData(grid, data) {
                        this.$nextTick(() => {
                            _.forEach(data, (item, index) => {
                                let rId = index + 1
                                if(grid.cells(rId, 7).getValue()==='Y') grid.setRowColor(rId,"coral");
                            })
                        })
                    }
                },
                title: '방문 관리',
                data: {},
                visitorList: [],
                visitorSeq: '',
                visitorNm: '',
                visitStat: '',
                blackInfoYn: false,
                today: this.$moment().format('YYYYMMDD'),
            };
        },
        methods: {
            constructGridSuccessful(grid) {
                grid.attachEvent('onRowSelect', (rId) => {
                    let visitorSeq = grid.cells(rId,0).getValue();
                    let visitorNm = grid.cells(rId,1).getValue();
                    this.visitorSeq = visitorSeq
                    this.visitorNm = visitorNm
                });
            },
            saveExcel() {
                this.downloadExcel(this.$refs.grid);
            },
        },
        mounted() {
        },
        watch: {
            value: {
                immediate: true,
                deep: true,
                handler(value) {
                    this.visitorList = value.visitDetails
                    this.visitStat = value.visitStatCd
                    if(this.visitorList.length !== 0) {
                        this.visitorSeq = this.visitorList[0].visitorSeq
                        this.visitorNm = this.visitorList[0].visitorNm
                        this.blackInfoYn = false
                        for(let i=0; i<this.visitorList.length; i++){
                            if(this.visitorList[i].blackYn==='Y')
                                this.blackInfoYn = true
                        }
                    }
                }
            },
        }
    };
</script>

<style scoped>
    .desc-content .item {
        float: left;
    }

    .desc-content .item .desc-item {
        position: relative;
        padding-left: 82px;
        margin-bottom: 8px;
    }

    .desc-content .item .desc-item:last-child {
        margin-bottom: 0;
        height: 25px;
    }

    .desc-content .item .desc-item .tit {
        position: absolute;
        left: 0;
    }

    .desc-content .item .desc-item .label-tit {
        font-family: 'NotoM';
        color: #222;
        font-size: 15px;
    }

    .desc-content .item.desc-left .desc-item {
        padding-left: 90px;
    }

    .desc-content .item.desc-left .desc-item .desc:after {
        clear: both;
        content: '';
        display: block;
    }

    .desc-content .item.desc-left .desc-item .desc .datepicker {
        float: left;
    }

    .desc-content .item.desc-left .desc-item .desc span.wave {
        float: left;
        padding: 0 6px;
    }

    .desc-content .item.desc-left .desc-item .td-s-thumb.search-area input,
    .desc-content .item.desc-left .desc-item .td-s-thumb.search-area .ip-box {
        float: left;
    }

    .desc-content .item.desc-left .desc-item .desc.select select {
        width: 70%;
    }

    .desc-content .item.desc-left {
        width: 35%;
        padding-right: 40px;
    }

    .desc-content .item.desc-center {
        width: 35%;
        padding-right: 40px;
    }

    .desc-content .item.desc-right {
        width: 30%;
    }

    .search-area input {
        position: relative;
    }

    .search-area .icon {
        position: absolute;
        right: 8px;
        top: 1px;
        z-index: 100;
        cursor: pointer;
        font-size: 16px;
        color: #555;
    }

    .search-border .td-s-thumb {
        position: relative;
        display: inline-block;
    }

    .search-border .td-s-thumb.search-area > input,
    .search-border .td-s-thumb.search-area > .ip-box
    .search-border .td-s-thumb.search-area > button {
        float: left;
    }

    .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
        width: 60%;
        margin-left: 6px;
    }

    .search-border .td-s-thumb.search-area .ip-box {
        vertical-align: top;
    }

    @media (max-width: 1580px) {
        .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
            width: 50%;
        }
    }
</style>

